
const bazarList = [
  {
    id: "mvp",
    label: "MVP Colony",
    title: "MVP Rythu Bazar",
    description:
      "The MVP Rythu Bazar in Visakhapatnam (Vizag) is a popular local market located in MVP Colony, offering fresh vegetables, fruits, and flowers directly from farmers at potentially lower prices.",
    time: "6:00 AM - 7:00 PM",
    holiday: "Tuesday Holiday",
    images: [
      "https://content3.jdmagicbox.com/v2/comp/hyderabad/l2/040pxx40.xx40.220125171654.w2l2/catalogue/rythu-bazar-kukatpally-hyderabad-59irncibtd.jpg",
      "https://www.connectingtraveller.com/images/localtip/1630871685images%20(21).jpeg",
      "https://media.andhrajyothy.com/media/2022/20221214/Untitled_3055_55d2d4511c.jpg",
      "https://www.yovizag.com/wp-content/uploads/2017/01/Paytm-Issue-Rythu-Bazaar_web4.webp"
    ],
    mapUrl:
      "https://www.google.com/maps?q=MVP%20Colony%20Rythu%20Bazar&output=embed"
  },
  {
    id: "narasimha",
    label: "Narasimhanagar",
    title: "Narasimhanagar Rythu Bazar",
    description:
      "Narasimhanagar Rythu Bazar serves fresh vegetables and fruits sourced directly from farmers for local residents.",
    time: "6:00 AM - 7:00 PM",
    holiday: "Tuesday Holiday",
    images: [
      "https://content3.jdmagicbox.com/v2/comp/hyderabad/l2/040pxx40.xx40.220125171654.w2l2/catalogue/rythu-bazar-kukatpally-hyderabad-59irncibtd.jpg",
      "https://www.connectingtraveller.com/images/localtip/1630871685images%20(21).jpeg",
      "https://media.andhrajyothy.com/media/2022/20221214/Untitled_3055_55d2d4511c.jpg",
      "https://www.yovizag.com/wp-content/uploads/2017/01/Paytm-Issue-Rythu-Bazaar_web4.webp"
    ],
    mapUrl:
      "https://www.google.com/maps?q=Narasimhanagar%20Rythu%20Bazar&output=embed"
  },
  {
    id: "gajuwaka",
    label: "Gajuwaka",
    title: "Gajuwaka Rythu Bazar",
    description:
      "One of the busiest Rythu Bazars in Vizag, providing affordable daily essentials directly from farmers.",
    time: "6:00 AM - 7:00 PM",
    holiday: "Tuesday Holiday",
    images: [
      "https://content3.jdmagicbox.com/v2/comp/hyderabad/l2/040pxx40.xx40.220125171654.w2l2/catalogue/rythu-bazar-kukatpally-hyderabad-59irncibtd.jpg",
      "https://www.connectingtraveller.com/images/localtip/1630871685images%20(21).jpeg",
      "https://media.andhrajyothy.com/media/2022/20221214/Untitled_3055_55d2d4511c.jpg",
      "https://www.yovizag.com/wp-content/uploads/2017/01/Paytm-Issue-Rythu-Bazaar_web4.webp"
    ],
    mapUrl:
      "https://www.google.com/maps?q=Gajuwaka%20Rythu%20Bazar&output=embed"
  },
  {
    id: "ukkunagaram",
    label: "Ukkunagaram",
    title: "Ukkunagaram Rythu Bazar",
    description:
      "Ukkunagaram Rythu Bazar supports local farmers and provides fresh produce to the surrounding areas.",
    time: "6:00 AM - 7:00 PM",
    holiday: "Tuesday Holiday",
    images: [
      "https://content3.jdmagicbox.com/v2/comp/hyderabad/l2/040pxx40.xx40.220125171654.w2l2/catalogue/rythu-bazar-kukatpally-hyderabad-59irncibtd.jpg",
      "https://www.connectingtraveller.com/images/localtip/1630871685images%20(21).jpeg",
      "https://media.andhrajyothy.com/media/2022/20221214/Untitled_3055_55d2d4511c.jpg",
      "https://www.yovizag.com/wp-content/uploads/2017/01/Paytm-Issue-Rythu-Bazaar_web4.webp"
    ],
    mapUrl:
      "https://www.google.com/maps?q=Ukkunagaram%20Rythu%20Bazar&output=embed"
  },
  {
    id: "gopalapatnam",
    label: "Gopalapatnam",
    title: "Gopalapatnam Rythu Bazar",
    description:
      "A well-known Rythu Bazar serving the northern parts of Vizag city.",
    time: "6:00 AM - 7:00 PM",
    holiday: "Tuesday Holiday",
    images: [
      "https://content3.jdmagicbox.com/v2/comp/hyderabad/l2/040pxx40.xx40.220125171654.w2l2/catalogue/rythu-bazar-kukatpally-hyderabad-59irncibtd.jpg",
      "https://www.connectingtraveller.com/images/localtip/1630871685images%20(21).jpeg",
      "https://media.andhrajyothy.com/media/2022/20221214/Untitled_3055_55d2d4511c.jpg",
      "https://www.yovizag.com/wp-content/uploads/2017/01/Paytm-Issue-Rythu-Bazaar_web4.webp"
    ],
    mapUrl:
      "https://www.google.com/maps?q=Gopalapatnam%20Rythu%20Bazar&output=embed"
  }
];


export default bazarList;